import { render } from "./ModuleUnderDevelopment.vue?vue&type=template&id=0d8371ab&scoped=true"
import script from "./ModuleUnderDevelopment.vue?vue&type=script&lang=js"
export * from "./ModuleUnderDevelopment.vue?vue&type=script&lang=js"

import "./ModuleUnderDevelopment.vue?vue&type=style&index=0&id=0d8371ab&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d8371ab"]])

export default __exports__